// ============================================================================
// SKU TYPES
// ============================================================================

/**
 * SKU Code enumeration for product SKUs used throughout the application
 */
export enum SkuCode {
  /** Bullying Prevention Unit */
  BPU = 'BPU',
  /** Child Protection Unit */
  CPU = 'CPU',
  /** K-8 Product */
  K8P = 'K8P',
  /** K-12 Product */
  K12P = 'K12P',
  /** K-5 Product */
  K5P = 'K5P',
  /** Middle School Product */
  MSP = 'MSP',
  /** High School Product */
  HSP = 'HSP',
  /** Adult Learning */
  ADL = 'ADL',
  /** Out of School Time */
  OST = 'OST',
  /** Second Step Program */
  SSP = 'SSP',
}

/**
 * Legacy SKU code names for backward compatibility
 * These map to the SkuCode enum values
 */
export const Skus = {
  BPUSkuCode: SkuCode.BPU,
  CPUSkuCode: SkuCode.CPU,
  K8SkuCode: SkuCode.K8P,
  K8FamilySkuCode: SkuCode.K8P,
  HighSchoolSkuCode: SkuCode.HSP,
  K12SkuCode: SkuCode.K12P,
  K12FamamilySkuCode: SkuCode.K12P,
  ADLSkuCode: SkuCode.ADL,
  MSPSkuCode: SkuCode.MSP,
  K5SkuCode: SkuCode.K5P,
} as const

/**
 * SKU codes that should be normalized to K8P
 * These are legacy SKU codes that map to the K-8 product
 */
export const NORMALIZED_SKU_CODES: readonly SkuCode[] = [
  SkuCode.MSP,
  SkuCode.K5P,
  SkuCode.K8P, // K8FamilySkuCode also maps to K8P
  SkuCode.K12P,
] as const
